var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarPoh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15799_8005)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 172,
    rx: 86,
    fill: "#F4E5D2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.875,
    y: 109.505,
    width: 28.1279,
    height: 34.619,
    rx: 14.064,
    fill: "#5D0F32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.618 122.486H35.9404C20.4058 122.486 7.8125 109.893 7.8125 94.3584C7.8125 78.8237 20.4058 66.2304 35.9404 66.2304H66.8093C67.0362 66.2304 67.2627 66.2319 67.4888 66.2348C73.7142 52.2124 87.7609 42.4326 104.092 42.4326H264.205C286.312 42.4326 304.233 60.3539 304.233 82.4608C304.233 104.568 286.312 122.489 264.205 122.489H104.092C103.934 122.489 103.776 122.488 103.618 122.486Z",
    fill: "#BC403A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.8125,
    y: 66.2324,
    width: 56.2559,
    height: 56.2559,
    rx: 28.1279,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.1,
    cy: 65.1501,
    r: 7.57291,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.179,
    cy: 66.2278,
    r: 4.32738,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.9538,
    cy: 65.1501,
    r: 7.57291,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.0325,
    cy: 66.2278,
    r: 4.32738,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.4408,
    cy: 99.7651,
    r: 3.24553,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.994,
    y: 68.3984,
    width: 28.1279,
    height: 75.7291,
    rx: 14.064,
    fill: "#8C1935"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.125,
    y: 42.4258,
    width: 23.8006,
    height: 80.0564,
    fill: "#5F3994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.432 122.485C161.432 123.054 161.292 123.616 161.02 124.141C160.748 124.666 160.35 125.143 159.847 125.545C159.345 125.947 158.749 126.266 158.093 126.483C157.436 126.701 156.733 126.813 156.023 126.813C155.312 126.813 154.609 126.701 153.952 126.483C153.296 126.266 152.7 125.947 152.198 125.545C151.695 125.143 151.297 124.666 151.025 124.141C150.753 123.616 150.613 123.054 150.613 122.485L161.432 122.485Z",
    fill: "#F29D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.615 42.4258C150.615 41.8575 150.755 41.2948 151.027 40.7698C151.299 40.2447 151.697 39.7677 152.199 39.3659C152.702 38.964 153.298 38.6453 153.954 38.4278C154.611 38.2103 155.314 38.0984 156.024 38.0984C156.735 38.0984 157.438 38.2103 158.094 38.4278C158.751 38.6453 159.347 38.964 159.849 39.3659C160.352 39.7677 160.75 40.2447 161.022 40.7698C161.294 41.2948 161.434 41.8575 161.434 42.4258L150.615 42.4258Z",
    fill: "#F29D4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.023,
    cy: 58.6553,
    r: 5.40922,
    fill: "#F29D4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.023,
    cy: 82.4639,
    r: 5.40922,
    fill: "#F29D4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.023,
    cy: 104.097,
    r: 5.40922,
    fill: "#F29D4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15799_8005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 172,
    rx: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPoh);
export default __webpack_public_path__ + "static/media/avatar-poh.6dea07c89fd75fed01ea65a4f4e45f11.svg";
export { ForwardRef as ReactComponent };